import { render, staticRenderFns } from "./AiReportMetricCard.vue?vue&type=template&id=04be9ab2&scoped=true"
import script from "./AiReportMetricCard.vue?vue&type=script&lang=ts"
export * from "./AiReportMetricCard.vue?vue&type=script&lang=ts"
import style0 from "./AiReportMetricCard.vue?vue&type=style&index=0&id=04be9ab2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04be9ab2",
  null
  
)

export default component.exports